import React from 'react';

import {
  MetaInfoContainer,
  Duration,
  TeacherLink,
} from '~/src/components/content-templates/MetaInfo';

import type { Content } from '../types';

import { Tags } from './Tags';

interface Props {
  content: Content;
}

export const MetaInfo: React.FC<Props> = ({ content }) => {
  const { teacher } = content;

  const mediaDuration = content?.media_duration || null;

  return (
    <MetaInfoContainer>
      <MetaInfoContainer.TagsContainer>
        <Tags content={content} />
      </MetaInfoContainer.TagsContainer>
      <TeacherLink teacher={teacher} />
      {mediaDuration && <Duration minutes={mediaDuration.minutes} />}
    </MetaInfoContainer>
  );
};
